import { defineStyleConfig } from '@chakra-ui/react';

export const Badge = defineStyleConfig({
  baseStyle: {
    borderRadius: 'full',
    px: 3,
    py: 1,
    fontSize: 'xs',
    fontWeight: 600,
    fontFamily: 'body',
    letterSpacing: '0.01em',
  },
});
